// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title {
  font-family: AppFontMedium;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.06em;
  text-align: center;
  color: var(--color-black);
  padding: 0 20px;
  text-transform: uppercase;
  font-weight: bold;
}

.info {
  font-family: AppFont;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
  padding: 10px 15px;
}

.grey {
  color: var(--color-black);
  opacity: 0.6;
}

.buttons_wrap {
  padding: 0 40px;
}
@media (max-width: 992px) {
  .buttons_wrap {
    padding: 0 20px;
  }
}
.buttons_wrap ion-button {
  width: 100%;
  margin-bottom: 10px;
  text-transform: uppercase;
}
.buttons_wrap ion-button:hover {
  --background: var(--primary-btn) !important;
}
.buttons_wrap .cancel {
  --background: transparent;
  --border-width: 0px;
  color: var(--color-black);
  text-decoration: underline;
}
.buttons_wrap .cancel:hover {
  --background: none !important;
}

ion-slides {
  --bullet-background-active: var(--ion-color-text) !important;
}

.second_box {
  width: 100%;
  padding: 0 5%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.box {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 20px;
}
.box:last-child {
  margin-bottom: 0;
}
@media (max-width: 992px) {
  .box {
    width: -moz-fit-content;
    width: fit-content;
  }
}
.box ion-img {
  width: 30%;
  min-width: 88px;
}
@media (max-width: 992px) {
  .box ion-img {
    width: 8%;
  }
}
.box .text-title {
  margin-left: 20px;
  font-weight: bold;
  font-size: 13px;
  font-family: AppFont;
  text-transform: uppercase;
  text-align: left;
}
.box .text {
  text-transform: uppercase;
  margin-left: 20px;
  font-family: AppFont;
  text-align: start;
  font-size: 11px;
}

swiper-container {
  --swiper-pagination-top: 53vh;
  --swiper-pagination-color: var(--ion-color-secondary);
}
@media (max-width: 420px) {
  swiper-container {
    --swiper-pagination-top: 46vh;
  }
}

.slide-info {
  margin-top: 6vh;
}

.img-wrapper {
  height: 100%;
  display: flex;
  align-items: center;
}

swiper-slide {
  display: flex;
  position: relative;
  flex-direction: column;
  flex-shrink: 0;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  text-align: center;
  box-sizing: border-box;
}
swiper-slide .block {
  width: 100%;
  height: 52vh;
}
@media (max-width: 420px) {
  swiper-slide .block {
    height: 44vh;
  }
}

swiper-slide img {
  width: auto;
  max-width: 100%;
  height: auto;
  max-height: 100%;
  min-height: 315px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/loyalty-components/loyalty-slider/loyalty-slider.component.scss"],"names":[],"mappings":"AACA;EACE,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,yBAAA;EAEA,YAAA;AADF;;AAIA;EACE,eAAA;AADF;AAEE;EAFF;IAGI,eAAA;EACF;AACF;AACE;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;AACJ;AACI;EACE,2CAAA;AACN;AAGE;EACE,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,0BAAA;AADJ;AAGI;EACE,6BAAA;AADN;;AAMA;EACE,4DAAA;AAHF;;AAMA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;AAHF;;AAMA;EACE,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;AAHF;AAKE;EACE,gBAAA;AAHJ;AAME;EAVF;IAWI,uBAAA;IAAA,kBAAA;EAHF;AACF;AAKE;EACE,UAAA;EACA,eAAA;AAHJ;AAII;EAHF;IAII,SAAA;EADJ;AACF;AAIE;EACE,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,yBAAA;EACA,gBAAA;AAFJ;AAKE;EACE,yBAAA;EACA,iBAAA;EACA,oBAAA;EAEA,iBAAA;EACA,eAAA;AAJJ;;AAQA;EACE,6BAAA;EAOA,qDAAA;AAXF;AAKE;EAFF;IAGI,6BAAA;EAFF;AACF;;AASA;EACE,eAAA;AANF;;AASA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AANF;;AASA;EACE,aAAA;EACA,kBAAA;EAEA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,2BAAA;EAEA,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,sBAAA;AATF;AAUE;EACE,WAAA;EACA,YAAA;AARJ;AASI;EAHF;IAII,YAAA;EANJ;AACF;;AAUA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AAPF","sourcesContent":["\n.title {\n  font-family: AppFontMedium;\n  font-size: 18px;\n  line-height: 22px;\n  letter-spacing: 0.06em;\n  text-align: center;\n  color: var(--color-black);\n  padding: 0 20px;\n  text-transform: uppercase;\n  font-weight: bold;\n}\n\n.info {\n  font-family: AppFont;\n  font-size: 13px;\n  line-height: 16px;\n  letter-spacing: 0em;\n  text-align: center;\n  color: var(--color-black);\n  text-transform: uppercase;\n  padding: 10px 15px;\n}\n\n.grey {\n  color: var(--color-black);\n\n  opacity: 0.6;\n}\n\n.buttons_wrap {\n  padding: 0 40px;\n  @media (max-width: 992px) {\n    padding: 0 20px;\n  }\n\n  ion-button {\n    width: 100%;\n    margin-bottom: 10px;\n    text-transform: uppercase;\n\n    &:hover {\n      --background: var(--primary-btn) !important;\n    }\n  }\n\n  .cancel {\n    --background: transparent;\n    --border-width: 0px;\n    color: var(--color-black);\n    text-decoration: underline;\n\n    &:hover {\n      --background: none !important;\n    }\n  }\n}\n\nion-slides {\n  --bullet-background-active: var(--ion-color-text) !important;\n}\n\n.second_box {\n  width: 100%;\n  padding: 0 5%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n}\n\n.box {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  margin-bottom: 20px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  @media (max-width: 992px) {\n    width: fit-content;\n  }\n\n  ion-img {\n    width: 30%;\n    min-width: 88px;\n    @media (max-width: 992px) {\n      width: 8%;\n    }\n  }\n\n  .text-title {\n    margin-left: 20px;\n    font-weight: bold;\n    font-size: 13px;\n    font-family: AppFont;\n    text-transform: uppercase;\n    text-align: left;\n  }\n\n  .text {\n    text-transform: uppercase;\n    margin-left: 20px;\n    font-family: AppFont;\n\n    text-align: start;\n    font-size: 11px;\n  }\n}\n\nswiper-container {\n  --swiper-pagination-top: 53vh;\n  @media (max-width: 420px) {\n    --swiper-pagination-top: 46vh;\n  }\n  //@media (max-width: 992px) {\n  //   --swiper-pagination-bottom: 0 !important;\n  //}\n  --swiper-pagination-color: var(--ion-color-secondary);\n}\n\n.slide-info {\n  margin-top: 6vh;\n}\n\n.img-wrapper {\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n\nswiper-slide {\n  display: flex;\n  position: relative;\n\n  flex-direction: column;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: flex-start;\n\n  width: 100%;\n  height: 100%;\n\n  text-align: center;\n  box-sizing: border-box;\n  .block {\n    width: 100%;\n    height: 52vh;\n    @media (max-width: 420px) {\n      height: 44vh;\n    }\n  }\n}\n\nswiper-slide img {\n  width: auto;\n  max-width: 100%;\n  height: auto;\n  max-height: 100%;\n  min-height: 315px;\n}\n\nion-img {\n  //@media (max-width: 992px) {\n  //     width: 40%;\n  //}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
